import { render } from '@testing-library/react';
import React from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { clearEdit } from '../../features/InfoSlice/infoSlice';
import { addToProductList } from '../../features/SalesSlice/SalesSlice';


const UpdateModal = ({ updateProduct, setUpdateProduct }) => {
    const products = useSelector((state) => state.salesInvoice.products);
    const [total, setTotal] = useState(false);
    const [changingRate, setChangingRate] = useState(false);
    const [quantity, setQuantity] = useState();
    const [defaultQuantity, setDefaultQuantity] = useState();
    const [salesRate, setSalesRate] = useState();
    const [addError, setAddEroor] = useState();
    const dispatch = useDispatch();

    console.log();


    const codeRef = useRef('');
    const nameRef = useRef('');
    const quantityRef = useRef();
    const rateRef = useRef();
    const totalRef = useRef();
    const costTk=products[0]?.purchase

    const addProduct = () => {
        const code = codeRef.current.innerText;
        const name = nameRef.current.innerText;
        const quantity = quantityRef.current.value;
        const rate = rateRef.current.value;
        const total = totalRef.current.value;
        const cost= parseInt(quantityRef.current.value)*parseInt(costTk)

        dispatch(addToProductList({ code, name, quantity, rate, total,cost }))
        setUpdateProduct(null);
    }

    const handleTotal = (event) => {
        const quantity = parseInt(event?.target?.value);
        setQuantity(quantity);
        setTotal(true);
    }
    const handleRate = (event) => {
        const rate = parseInt(event?.target?.value);
        const quantity = parseInt(quantityRef.current.value);
        setDefaultQuantity(quantity)
        setSalesRate(rate);
        setChangingRate(true);
    }

    const closeModal = () => {
        setUpdateProduct(null);
    }

    return (
        <div>
            <input type="checkbox" id="update-modal" class="modal-toggle" />
            <div class="modal">
                <div class="modal-box max-w-none w-8/12 relative">
                    <label for="update-modal" onClick={closeModal} class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <h3 class="text-lg text-center font-bold">Add Product <span className='text-error'>{addError}</span></h3>
                    <table class="table w-1/2 mx-auto">
                        <thead className='text-center'>
                            <tr>
                                <th className='bg-primary text-white normal-case'>Product Code</th>
                                <th className='bg-primary text-white normal-case'>Product Name</th>
                                <th className='bg-primary text-white normal-case'>Quantity</th>
                                <th className='bg-primary text-white normal-case'>Rate</th>
                                <th className='bg-primary text-white normal-case'>Total</th>
                                <th className='bg-primary text-white normal-case'>Action</th>
                            </tr>
                        </thead>
                        <tbody className='text-center'>
                            {
                                products.map(product => <tr className='hover'>
                                    <td className='text-sm' ref={codeRef}>{product.code}</td>
                                    <td className='text-sm' ref={nameRef}>{product.name}</td>
                                    <td><input ref={quantityRef} onChange={handleTotal} type="number" defaultValue={product.quantity} placeholder="Type here" className="input text-center input-bordered w-28 max-w-lg" /></td>
                                    <td><input ref={rateRef} onChange={handleRate} type="number" defaultValue={product.sell} placeholder="Type here" className="input text-center input-bordered w-28 max-w-lg" /></td>
                                    <td><input ref={totalRef} type="number" value={total === false ? product.sell : changingRate === true ? quantity * salesRate  : quantity * parseInt(product?.sell)} placeholder="Type here" className="input text-center input-bordered w-40 max-w-lg" /></td>
                                    <td> <button onClick={addProduct} className={`btn`}>Add Product</button> </td>
                                </tr>)
                            }

                        </tbody>
                    </table>

                </div>
            </div >
        </div >
    );
};

export default UpdateModal;